module.exports = __webpack_public_path__ + "img/join-our-community.5501006f.svg";